// export default 'development'
export default 'stagging'


// WEBPACK FOOTER //
// ./src/mode.js